import React from 'react';
import { useIntl } from 'react-intl';
import { message } from 'antd';
import { Ability, useAuth } from '../../../../hooks/useAuth';
import PublicRoute from 'enums/publicRoutes';
import { adminPath } from 'enums/adminRoutes';

interface ProtectedRouteProps {
  children: React.ReactNode;
  authenticated?: boolean;
  requiresAdmin?: boolean;
  requiresFarmAdmin?: boolean;
  requiresWholesaleContract?: boolean;
  ability?: Ability;
}

const ProtectedRoute = ({
  children,
  requiresAdmin,
  requiresFarmAdmin,
  requiresWholesaleContract,
  ability,
}: ProtectedRouteProps) => {
  const intl = useIntl();
  const { user, isFetchingUser, can } = useAuth();

  const isFarmAdmin = user?.isFarmOwner;
  const isSuperAdmin = user?.isAdmin;
  const hasWholesaleContract = user?.farm?.has_wholesale_contract ?? false;

  if (isFetchingUser) {
    return null;
  }

  if (isSuperAdmin) {
    return <>{children}</>;
  }

  if (!user?.authenticated) {
    if (localStorage.getItem('wasLoggedIn') === '1') {
      localStorage.removeItem('wasLoggedIn');
      sessionStorage.setItem('pendingLoginError', 'message.session_expired');
    }
    window.location.href = PublicRoute.LOGIN;
    return null;
  }

  if (requiresAdmin && !isSuperAdmin) {
    window.location.href = PublicRoute.HOME;
    return null;
  }

  if (requiresFarmAdmin && !isFarmAdmin) {
    window.location.href = PublicRoute.HOME;
    return null;
  }

  if (requiresWholesaleContract && !hasWholesaleContract) {
    message.warning(
      intl.formatMessage({
        id: 'message.wholesale_contract_required_for_listings',
      })
    );
    window.location.href = adminPath.farmContracts();
    return null;
  }

  if (ability && !can(ability)) {
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
